import { render, staticRenderFns } from "./agenda-detail.vue?vue&type=template&id=c316a758&"
import script from "./agenda-detail.vue?vue&type=script&lang=js&"
export * from "./agenda-detail.vue?vue&type=script&lang=js&"
import style0 from "./agenda-detail.vue?vue&type=style&index=0&id=c316a758&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports